export { DialogLapDelete } from './dialog-lap-delete';
